"use client";

import { motion } from "framer-motion";

export interface ProjectVideoBlockStyle {
    paddingTop?: string;
    paddingBottom?: string;
    backgroundColor?: string;
}

export interface ProjectVideoBlockProps {
    videoUrl: string;
    poster?: string; // Optional poster image
    autoPlay?: boolean;
    style?: ProjectVideoBlockStyle;
}

export default function ProjectVideoBlock({
    videoUrl,
    poster,
    autoPlay = true,
    style
}: ProjectVideoBlockProps) {
    if (!videoUrl) return null;

    return (
        <div
            className="w-full"
            style={{
                backgroundColor: style?.backgroundColor || "#FFFFFF",
                paddingTop: style?.paddingTop || "0rem",
                paddingBottom: style?.paddingBottom || "0rem",
            }}
        >
            <div className="w-full">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="relative w-full aspect-video md:aspect-[21/9] overflow-hidden"
                >
                    <video
                        className="absolute inset-0 w-full h-full object-cover"
                        playsInline
                        autoPlay={autoPlay}
                        muted={autoPlay} // Autoplay requires mute usually
                        loop
                        poster={poster}
                        controls={!autoPlay}
                    >
                        <source src={videoUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </motion.div>
            </div>
        </div>
    );
}
